<template>
  <div class="dropdown-menu chat-drop-menu dropdown-menu-end">
    <a href="javascript:;" class="dropdown-item message-info-left"
      ><span><i class="bx bx-info-circle"></i></span>Message Info
    </a>
    <a href="javascript:;" class="dropdown-item"
      ><span><i class="bx bx-share"></i></span>Reply</a
    >
    <a href="javascript:;" class="dropdown-item"
      ><span><i class="bx bx-smile"></i></span>React</a
    >
    <a href="javascript:;" class="dropdown-item"
      ><span><i class="bx bx-star"></i></span>Star Message</a
    >
    <a
      href="javascript:;"
      class="dropdown-item"
      data-bs-toggle="modal"
      data-bs-target="#delete-message"
      ><span><i class="bx bx-trash"></i></span>Delete</a
    >
  </div>
</template>
